<template>
	<footer><!-- <p class="content">Team - Shandar sir, Sandesha mam, Kushal & Rohan</p> --></footer>
</template>
<script>
export default {
	name : 'Footer',
	data(){
		return {
			
		}
	}
}	
</script>
<style scoped>
footer{
	text-align: center;
}	
</style>